export default "__VITE_ASSET__c19ism0l__"